import React from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from "@chakra-ui/react";

import { useCustomToast, useStoreHistory } from "@hooks";
import { SearchMarkup } from "./SearchMarkup";

export function SerialNumberSearch() {
  const navigate = useNavigate();
  const storeHistory = useStoreHistory();

  const invalidToast = useCustomToast(() => (
    <Alert status="error">Please enter a search string.</Alert>
  ));

  const notFoundToast = useCustomToast(() => (
    <Alert status="error">No parts found with that serial number.</Alert>
  ));

  const newSearch = React.useCallback(
    (queryString: string) => {
      if (!queryString) invalidToast();
      if (storeHistory["auxiliary-components"].includes(queryString))
        return navigate(`auxiliary-components/${queryString}`);
      if (storeHistory.modules.includes(queryString))
        return navigate(`modules/${queryString}`);
      if (storeHistory.components.includes(queryString))
        return navigate(`components/${queryString}`);
      return notFoundToast();
    },
    [navigate, notFoundToast, invalidToast],
  );

  return <SearchMarkup search={newSearch} />;
}
